import { Component, OnInit } from '@angular/core';
import {
  IonApp,
  IonRouterOutlet,
  ModalController,
  IonMenu,
  IonHeader,
  IonIcon,
  IonToolbar,
  IonContent,
  IonList,
  IonMenuToggle,
  IonItem,
  IonLabel
 } from '@ionic/angular/standalone';
import { EventService } from './_services/event.service';
import { AuthenticationService } from './_services/authentication.service';
import { Router } from '@angular/router';
import { logOut, helpCircle } from 'ionicons/icons';
import { addIcons } from 'ionicons';
import { UserService } from './_services/user.service';
import { AsyncPipe } from '@angular/common';
import { BehaviorSubject } from 'rxjs';

interface User {
  full_name: string;
  username: string;
  nif: string;
}

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [IonApp, IonRouterOutlet,IonMenu,IonHeader,IonToolbar,IonContent,IonList,IonMenuToggle,IonIcon,IonItem,IonLabel, AsyncPipe],
  providers: []
})
export class AppComponent implements OnInit {
  currentUser = this.userService.currentUser as BehaviorSubject<User | null>;

  constructor(
    private eventService: EventService,
    private modalController: ModalController,
    private authService: AuthenticationService,
    private router: Router,
    private userService: UserService
  ) {
    addIcons({ logOut, helpCircle });
  }

  ngOnInit() {

  }

  async logout() {
    await this.authService.logout();
    this.router.navigate(['/login']);
  }

  abrirManual() {
    this.router.navigate(['/manual-usuario']);
  }
}
